import React, { useEffect } from "react";
import { Landing } from "./pages/Landing";
import { initMetaPixel } from "./utils/metaPixel";
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <Landing data-id="element-0" data-mp="3ka4dp9mrapn1" />;
}